// Fix e.g for search when &role=A,B is treated in backend as AND
// when in fact we need OR-like behaviour, so we need to construct &role=A&role=B
export class GetParamsExpandableArrayWrapper {
  constructor(public content: Array<any>) { }
}
